<template>
  <div>
    <b-card class="bg-t-dark">
        <b-row>
            <b-col md="2">
                <b-row>
                    <b-col class="text-center">
                        <EnlightMockupImg/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="text-center mt-2">
                        <h5>
                            ENLIGHT 2100
                        </h5>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="10">
                <b-row>
                    <b-col md="8">
                        {{$t("Client")}}: <b>Hospital Geral de Cuidados</b>
                    </b-col>
                    <b-col md="4" class="text-end-od">
                        {{$t("Status")}}: <b class="text-t-warning">Pending</b>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="4">
                        <b-row class="mt-1">
                            <b-col>
                                {{$t("Date")}}: YY/MM/DD
                            </b-col>
                        </b-row>
                        <b-row class="mt-1">
                            <b-col>
                                Location
                            </b-col>
                        </b-row>
                        <b-row class="mt-1">
                            <b-col>
                                {{$t("Mode")}}: Normal - Anvisa
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="4">
                        <b-row class="mt-1 mt-om">
                            <b-col md="5" class="text-end-od">
                                {{$t("Modules")}}:
                            </b-col>
                            <b-col md="7">
                                <b-row>
                                    <b-col>
                                        Assincronia
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        Titulação de PEEP
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        TVz + EELZ
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        Sensorless
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="4" class="text-end" align="end">
                        <b-row class="order-card-buttons  mt-om">
                            <b-col>
                                <b-btn class="m-2" variant="outline-t-blue" @click="approved=false">
                                    <b-icon-x/>
                                    {{$t("Disapprove")}}
                                </b-btn>
                                <b-btn v-if="!approved" class="m-2" variant="t-blue" @click="approve">
                                    <b-icon-check/>
                                    {{$t("Approve")}}
                                </b-btn>
                                <b-btn v-else class="m-2" variant="t-green" @click="approve">
                                    <b-icon-check/>
                                    {{$t("Approved")}}
                                </b-btn>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-card>
    <b-modal :id="`approvation-modal${order_id}`" centered size="md">
        <template #modal-title>
            Are you sure you want to approve this order?
        </template>
        <div>
            <b-row>
                <b-col>
                    Equipment: 
                    <b>ENLIGHT 2100</b>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    Client: 
                    <b>Hospital Geral de Cuidados Especiais</b>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    Location: 
                    <b>Brazil</b>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    Mode: 
                    <b>Basic</b>
                </b-col>
            </b-row>
            <br>
            <b-row>
                <b-col>
                    <b>Activations of the following modules will be released:</b>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    Lorem ipsum dolor, sit amet consectetur adipisicing elit. Illum in deserunt rer.
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <b-row align="end" align-h="end">
                <b-col>
                    <b-btn variant="t-blue" @click="approve_confirmation">
                        Approve order
                    </b-btn>
                </b-col>
            </b-row>
        </template>
    </b-modal>
    <b-modal :id="`approvation-success${order_id}`" hide-footer centered size="md">
        <template #modal-title>
            &nbsp;
        </template>
        <div>
            <b-row class="text-center">
                <b-col align="center">
                    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1" y="1" width="118" height="118" rx="49" fill="white" stroke="#C0C0C0" stroke-width="2"/>
                        <path d="M51.3802 71.9526L38.0473 58.6189L33.3333 63.333L51.3802 81.3807L88.0468 44.7141L83.3328 40L51.3802 71.9526Z" fill="#1F8B24"/>
                    </svg>
                </b-col>
            </b-row>
            <br>
            <b-row class="text-center mt-3">
                <b-col>
                    <b>Order released successfully!</b>
                </b-col>
            </b-row>
            <b-row class="text-center">
                <b-col>
                    <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius nemo reiciendis, quae voluptatem quibusdam possimus eveniet mollitia fuga voluptatum deleniti sed sit, dignissimos numquam nobis repellendus aliquid sunt iste error.</span>
                </b-col>
            </b-row>
            <br>
            <br>
        </div>
    </b-modal>
  </div>
</template>

<script>
import EnlightMockupImg from '@/assets/img/EnlightMockupImg'

export default {
    components:{
        EnlightMockupImg
    },
    props:{
        order_id: {
            type:String
        }
    },
    data(){
        return{
            approved: false
        }
    },
    methods:{
        approve(){
            this.$bvModal.show(`approvation-modal${this.order_id}`)
        },
        approve_confirmation(){
            this.approved=true
            this.$bvModal.hide(`approvation-modal${this.order_id}`)
        }
    },
    watch:{
        approved(v){
            if(v){
                this.$bvModal.show(`approvation-success${this.order_id}`)
            }
        }
    }
}
</script>

<style lang="scss">
@media only screen and (max-width: 600px) {
    .btn{
        margin-bottom: 5px;
    }
}
@media only screen and (min-width: 600px) {
    .order-card-buttons{  
        position: absolute;
        bottom: 15px;
        right: 15px;
        width: 33.33333333% !important;
    }
}
</style>